module.exports = __webpack_public_path__ + "static/img/wireframe-1.53ffc862.jpg";